// 지도관제, 목록관제가 같이 쓰는 헬퍼.
// 나중에 정리 되면 디렉토리등도 공용으로 사용할 수 있게 조정.
import { mapControl } from '@/constants';
import { orderStatus, } from '@/constants/orderStatus';
import { trimSpace } from '@/utils';
import { PAY_CARD_AMOUNT, PAY_CASH_AMOUNT, PRE_PAY_AMOUNT, } from '@/constants/payMethod';
import { orderTypeCode } from '@/constants/global';
import { MapWorker } from './model';
const { orderStatusGroup, orderStatusGroupList, mapControlAttendCode, mapControlWorkerFilterGroup, } = mapControl;
const mappedPayTypeOptionsValue = {
    PAY_CASH_AMOUNT,
    PAY_CARD_AMOUNT,
    PRE_PAY_AMOUNT,
};
/**
 * 배차, 픽업 카운트 연산
 * @param param0
 * @returns {number}
 */
const sum = ({ allocatedCount, pickupCount }) => (allocatedCount + pickupCount);
/**
 * 현재 필터에 속하는지 여부
 * @param statusCode 주문상태
 * @param filterList 필터 리스트. 기본값 ALL
 * @returns 포함되면 true, 포함되지 않으면 false
 */
export const isIncludedCurrentFilter = (statusCode, filterList = [
    orderStatusGroupList.ALL.code,
]) => {
    if (filterList.includes(orderStatusGroupList.ALL.code)) {
        return true;
    }
    const groupCode = orderStatusGroup[statusCode];
    return filterList.includes(groupCode);
};
/**
 * 배달 필터 적용된 배달리스트
 * @param orderListHashMap 주문 리스트
 * @param filterList
 * @param cb callback function
 * @returns
 */
export const getFilteredOrderList = (orderListHashMap, filterList, cb) => {
    const result = {};
    Object.entries(orderListHashMap).forEach(([orderId, order,]) => {
        if (isIncludedCurrentFilter(order.statusCode, filterList)
            && cb(order)) {
            result[orderId] = order;
        }
    });
    return result;
};
/**
 * 라이더 상태 필터 그룹 찾기
 * @param filterList 워커 필터 아이디 배열
 * @param workerAttendCode 워커 상태 코드
 * @returns {boolean}
 */
export const findWorkerStatusGroup = (filterList, workerAttendCode) => filterList.some((filterId) => mapControlWorkerFilterGroup[filterId].find((key) => key === workerAttendCode));
/**
 * 워커 데이터 필터에 포함 여부
 * @param workerData 워커 데이터
 * @param selectedFilterList 필터 아이디 배열
 * @returns {boolean} true 필터에 포함 됨. false 필터에 포함 x
 */
export const includedWorkerFilter = ({ user, }, selectedFilterList) => {
    const { attendCode } = user;
    // 필터 관련 프로세스
    // 필터가 있을 때만 분기
    const [firstWorkerFilterId,] = selectedFilterList;
    if (firstWorkerFilterId !== mapControlAttendCode.ALL.code) {
        // 필터 적용 필요 없을시
        if (!findWorkerStatusGroup(selectedFilterList, attendCode)) {
            return false;
        }
    }
    return true;
};
/**
 * 지도에 도착지가 보이는지 여부
 * @param drops 도착지 데이터
 * @param mkDrops 도착지 마커 데이터
 * @param mapBounds mapBounds 객체
 */
export const isShowSomeDropMarker = (drops, mkDrops, mapBounds) => Object.keys(drops).some((key) => {
    const { orderId } = drops[key];
    const mkDrop = mkDrops[orderId];
    if (!mkDrop) {
        return false;
    }
    const pos = mkDrop.getPosition();
    if (mapBounds.hasLatLng(pos)) {
        return true;
    }
    return false;
});
/**
 * 라이더 상태에 따른 그룹 판단
 * @param worker
 * @returns
 */
export const parseWorkerAttendCode = ({ user }) => {
    switch (user.attendCode) {
        case mapControlAttendCode.WAITING.code: return mapControlAttendCode.WAITING.code;
        case mapControlAttendCode.ALLOCATED.code:
        case mapControlAttendCode.DRIVING.code: return mapControlAttendCode.DRIVING.code;
        case mapControlAttendCode.REST.code: return mapControlAttendCode.REST.code;
        default: return '';
    }
};
/**
 * 지도관제, 목록관제 같이 씀
 * 발주유형, 결제방법등 셀렉터
 * @param orderList
 * @param selectedOwnerType 발주유형
 * @param selectedPayType 결제방법
 * @param selectedOrderAgencyType 주소기반
 * @returns
 */
export const getOrdersWithSelectType = (orderList = {}, selectedOwnerType, selectedPayType, selectedOrderAgencyType) => {
    const all = 'ALL';
    const mappedSelectOption = {
        orderAgencyType: selectedOrderAgencyType,
        ownerType: selectedOwnerType,
        payType: selectedPayType,
        // 검색은 여기서 안쓰임. 리팩토링 필요.
        searchWordType: '',
        searchWord: '',
    };
    const result = {};
    const isAll = [
        selectedOwnerType,
        selectedPayType,
        selectedOrderAgencyType,
    ].every((value) => value === all);
    if (isAll) {
        return orderList;
    }
    Object.entries(orderList).forEach(([orderId, order,]) => {
        // @ts-ignore
        const isMine = Object.entries(mappedSelectOption).every(([targetSelect, selectedOptionValue,
        // eslint-disable array-bracket-newline
        ]) => {
            if (selectedOptionValue === all) {
                return true;
            }
            // 결제종류 (카드. 현금..)
            if (targetSelect === 'payType') {
                return order.payMethod
                    // eslint-disable-next-line arrow-body-style
                    .some(({ code }) => {
                    return code === mappedPayTypeOptionsValue[selectedOptionValue];
                });
            }
            // 발주유형
            if (targetSelect === 'ownerType') {
                // TODO enum 값들 대문자로 통일하도록 해야 함. 계속 바꿔줘야 하는 상황 지속 됨 tg0825 20240113
                return order.orderType.toUpperCase() === selectedOptionValue;
            }
            // 주소기반
            if (targetSelect === 'orderAgencyType') {
                return order.orderAgencyId === selectedOptionValue;
            }
            // TODO 여기서 검색어는 안하네? 개선 필요
            if (targetSelect === 'searchWordType'
                || targetSelect === 'searchWord') {
                return true;
            }
            return false;
        });
        if (isMine) {
            result[orderId] = order;
        }
    });
    return result;
};
/**
 * 검색조건
 * @param filteredOrder 오더에서 조건필드만 필터한 내용
 * @param searchOrderQuery 검색어
 */
export const searchCondition = (filteredOrder, searchOrderQuery) => filteredOrder.some(([, value,]) => trimSpace(value?.toString())?.toLowerCase().includes(searchOrderQuery));
/**
 * 검색어 필터된 주문 리스트 조회
 * @param orderList
 * @param searchOrderQuery 검색어
 */
export const getOrdersWithSearchQuery = (orderList = {}, _searchOrderQuery = '') => {
    let searchKeys = [
        'orderId',
        'hubName',
        'todayNumber',
        'storeName',
        'allocatedWorkerName',
        'allocatedHubName',
    ];
    let filteredOrderList = {};
    const searchOrderQuery = _searchOrderQuery.toLowerCase();
    if (searchOrderQuery) {
        Object.entries(orderList).forEach(([key, order,]) => {
            const isQuick = order.typeCode === orderTypeCode.QUICK;
            const trimmed = order._trimAddress();
            // 퀵일 경우 출발지주소 사용 , 출발지주소있으면 출발지주소, delivery중 픽업메모가 없으면 상점이름, 픽업메모있으면 픽업메모
            const targetText = isQuick
                ? trimmed.fullPickupAddress ?? ''
                : (trimmed.pickupAddressMemo || trimmed.storeName) ?? '';
            // 검색어 길이가 4개 이하일때에는 orderId 제외하고 검색
            searchKeys = searchOrderQuery.length <= 4 ? searchKeys.filter((item) => item !== 'orderId') : searchKeys;
            const filteredOrder = Object.entries(order).filter((id) => searchKeys.includes(id[0]));
            const hasSearchOrderQuery = searchCondition(filteredOrder, searchOrderQuery);
            if (targetText.toLowerCase().includes(searchOrderQuery)
                || hasSearchOrderQuery
                || trimmed.fullDropAddressShorten.toLowerCase().includes(searchOrderQuery)) {
                filteredOrderList[key] = order;
            }
        });
    }
    else {
        filteredOrderList = orderList;
    }
    return filteredOrderList;
};
/**
 * 검색어 필터된 주문 리스트 조회 (특정 필드)
 * @param orderList
 * @param searchOrderQuery 검색어
 */
export const getOrdersWithSearchWord = (orderList = {}, _searchWord = '', _searchWordType = '') => {
    const searchOrderQuery = _searchWord.toLowerCase();
    if (!searchOrderQuery) {
        return orderList;
    }
    return Object.values(orderList).reduce((acc, it) => {
        const { orderId } = it;
        const currentValue = orderList[orderId][_searchWordType] ?? '';
        if (String(currentValue).includes(_searchWord)) {
            acc[orderId] = it;
        }
        return acc;
    }, {});
};
/**
 * 워커 정렬
 * @param _origin 워커 리스트
 * @returns
 */
export const sortWorkerList = (_origin) => {
    const temp = {
        WAITING: [],
        DRIVING: [],
        SHARE: [],
        REST: [],
    };
    // 1. attendCode 분리
    Object.values(_origin).forEach((worker) => {
        const { user, isShareWorker } = worker;
        const { attendCode } = user;
        if (isShareWorker) {
            temp.SHARE.push(worker);
            return;
        }
        if (temp[mapControl.mapControlWorkerAttendCodeGroup[attendCode]]) {
            temp[mapControl.mapControlWorkerAttendCodeGroup[attendCode]].push(worker);
        }
        else {
            console.log('[sortWorkerList] attendCode: ', attendCode, temp[mapControl.mapControlWorkerAttendCodeGroup[attendCode]]);
        }
    });
    // 2. attendCode 순회 + 정렬
    Object.entries(temp).forEach(([key, worker]) => {
        if (key === mapControl.mapControlAttendCode.WAITING.code) {
            worker.sort(({ user: aUser }, { user: bUser }) => aUser.name.localeCompare(bUser.name));
            return;
        }
        worker.sort((aWorker, bWorker) => {
            const aSum = sum(aWorker);
            const bSum = sum(bWorker);
            // 카운트 같을 경우 이름순
            if (aSum === bSum) {
                return aWorker.user.name.localeCompare(bWorker.user.name);
            }
            if (aSum > bSum) {
                return 1;
            }
            return -1;
        });
    });
    return [
        ...temp.WAITING,
        ...temp.DRIVING,
        ...temp.SHARE,
        ...temp.REST,
    ];
};
/**
 * 목록관제 주문 정렬
 */
export const listControlSortOrderList = (_originOrderData) => {
    const temp = {
        [orderStatus.ACCEPTED.code]: [],
        [orderStatus.ALLOCATED.code]: [],
        [orderStatus.PICKUP.code]: [],
        [orderStatus.SELF.code]: [],
        [orderStatus.DROP_FINISHED.code]: [],
        [orderStatus.CANCELED.code]: [],
    };
    // 1. orderStatus 분리
    Object.values(_originOrderData).forEach((order) => {
        const { orderId, statusCode, } = order;
        const group = temp[orderStatusGroup[statusCode]];
        if (!group) {
            // TODO 해결 필요
            console.log(`[sortOrderList] 정렬 그룹에 속하지 않음. orderId: ${orderId}, statusCode: ${statusCode}`);
            return;
        }
        group.push(order);
    });
    // 2. 정렬
    Object.entries(temp).forEach(([key, order,]) => {
        const remainTimeType = [
            orderStatusGroupList.ACCEPTED.code,
            orderStatusGroupList.ALLOCATED.code,
        ];
        const delayTimeType = [
            orderStatusGroupList.PICKUP.code,
        ];
        if (remainTimeType.includes(key)) {
            order.sort((aOrder, bOrder) => (aOrder.pickupExpectedAt < bOrder.pickupExpectedAt ? -1 : 1));
        }
        if (delayTimeType.includes(key)) {
            order.sort((aOrder, bOrder) => (aOrder.pickedUpAt < bOrder.pickedUpAt ? -1 : 1));
        }
    });
    return Object.values(temp).reduce((acc, value) => {
        acc.push(...value);
        return acc;
    }, []);
};
/**
 * 지도 관제 주문 정렬, 목록관제와 비교해서 통합 가능하면 통합
 * @param _originOrderData 원본 주문 리스트
 * @returns
 */
export const mapControlSortOrderList = (_originOrderData) => {
    const temp = {
        [orderStatus.ACCEPTED.code]: [],
        [orderStatus.ALLOCATED.code]: [],
        [orderStatus.PICKUP.code]: [],
    };
    // 1. orderStatus 분리
    Object.values(_originOrderData).forEach((order) => {
        const { orderId, statusCode, } = order;
        const group = temp[orderStatusGroup[statusCode]];
        if (!group) {
            // TODO 해결 필요
            console.log(`[sortOrderList] 정렬 그룹에 속하지 않음. orderId: ${orderId}, statusCode: ${statusCode}`);
            return;
        }
        group.push(order);
    });
    // 2. 정렬
    Object.entries(temp).forEach(([key, order,]) => {
        const remainTimeType = [
            orderStatusGroupList.ACCEPTED.code,
            orderStatusGroupList.ALLOCATED.code,
        ];
        const delayTimeType = [
            orderStatusGroupList.PICKUP.code,
        ];
        if (remainTimeType.includes(key)) {
            order.sort((aOrder, bOrder) => (aOrder.pickupExpectedAt < bOrder.pickupExpectedAt ? -1 : 1));
        }
        if (delayTimeType.includes(key)) {
            order.sort((aOrder, bOrder) => (aOrder.pickedUpAt < bOrder.pickedUpAt ? -1 : 1));
        }
    });
    return Object.values(temp).reduce((acc, value) => {
        acc.push(...value);
        return acc;
    }, []);
};
/**
 * 워커 데이터 파싱
 * 공유 워커 유무 + 토탈 카운트
 * @param subscribeId
 * @param fulfillmentData
 * @returns
 */
export const parseWorkerData = (subscribeId, fulfillmentData) => {
    const result = {};
    fulfillmentData.forEach((_worker) => {
        const worker = new MapWorker(_worker);
        worker.setShareWorker(subscribeId);
        worker.updateTemporallyOffState();
        // 대기중인 공유 라이더
        if (worker.isWaitingShareWorker) {
            return;
        }
        // 퇴근 라이더 출력 x
        if (worker.isOffWorker) {
            return;
        }
        result[worker.code] = worker;
    });
    return result;
};
/**
 * 배차관련 요청 불가 여부
 * 선택된 주문에 요기배달이 있다면 여러건 선택해서 요청할 수 없다.
 * true 불가, false 가능
 */
export const isImpossibleRequest = (selectedOrderItemsObj) => {
    const arrayOrderList = Object.values(selectedOrderItemsObj);
    const isOneCount = arrayOrderList.length === 1;
    // 한개면 요청 가능
    if (isOneCount) {
        return false;
    }
    // 주소기반 주문이면 불가 (요기, 배민등)
    const isExistAgencyOrder = arrayOrderList
        .some((order) => order.isAddressBaseOrder());
    return isExistAgencyOrder;
};
// 선택된 항목중에 선택된 라이더의 건이 포함 되어 있으면 배차 버튼 노출 x
// 배차 요청 상태면 배차 아닌 것으로 판단
// TODO (statusCode !== orderStatus.WORKER_REQUESTED.code) 조건의 경우 안전성 확보시 추후 제거 가능.
export const hasSelectedOrdersInSelectedWorkerOrders = (code, orderList) => (orderList.some(({ statusCode, allocatedWorkerCode, }) => (
// 배차요청건은 접수건으로 본다. 접수건은 배차되기 전이기에 채크하지 않는다.
statusCode !== orderStatus.WORKER_REQUESTED.code
    && statusCode !== orderStatus.ACCEPTED.code
    && allocatedWorkerCode === code)));
